$.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};
$(document).ready(function () {
    $('.mainNavbar .navbar-collapse ul li a').on('click', function() {
        $('.mainNavbar .navbar-collapse').removeClass('show')
    })
    if ($('.page-home').length > 0) {
        new WOW().init();
    }
    if ($('#whatsappCall').length > 0) {
        setTimeout(() => {
            $('#whatsappCall').addClass('active');
        },1500);

        $('#whatsappCallDismiss').on('click', function() {
            $('#whatsappCall').removeClass('active');
            setCookie('dismissWhastapp',1,30,'/');
        });
        
    }
    $('img.lazyload').Lazy();
    $('.datepicker input').datetimepicker({
        format: 'L'
    });
    if ($('#cookieBanner').length > 0) {
        $('#cookieBanner').slideDown();
    }
    $('#acceptCookieBtn').on('click', function() {
        setCookie('accept_cookie',1,365,'/');
        $('#cookieBanner').slideUp();
    });
    $('[data-toggle="class"').on('click', function (e) {
        e.preventDefault();
        var target = $(this).data('target');
        var curClass = $(this).data('class');
        if (!target || !curClass) return;
        $(target).toggleClass(curClass);
    });

    $('[data-role="show-password"]').on('click', function () {
        var inpPass = $(this).closest('div').find('input');
        if ($(inpPass).attr('type') == 'password') {
            $(inpPass).attr('type','text');
        } else {
            $(inpPass).attr('type','password');
        }

    });


    if($('.has-error').length > 0 && $('.page-registrati').length > 0) {
        $('html, body').animate({
            scrollTop: $('.has-error:first').offset().top - $('#mainNavbar').outerHeight()
        }, 500);

        $('.has-error input,.has-error select').bind('keyup change', function () {
            if ($(this).val().trim() == '') return false;
            var div = $(this).closest('.has-error');
            div.removeClass('has-error');
            div.find('.error-label[data-type="validetor-error"]').remove();
        });
    }

    if ( $('.page-servizi').length > 0 ) {

            var $gallery = $('.grid-gallery a.lightbox').simpleLightbox();


    }

});
